import { render, staticRenderFns } from "./DeliveryFeesPostalCodeForm.vue?vue&type=template&id=50ab4ff9"
import script from "./DeliveryFeesPostalCodeForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryFeesPostalCodeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports